#import "../../../../core/schema/fragments/InquiryFull.graphql"

mutation (
  $input: InquiryCreateInput!
) {
  sendInquiry(
    input: $input
  ) {
    ...InquiryFull
  }
}
